import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  getUniqueCategories,
  getUniqueSubCategories,
  getUniqueBrands,
  getUniqueTemplates,
  getUniqueSeasons,
  getUniqueTags,
  getUniqueColors,
  getProductsUniqueSizes,
} from "../../helpers/product";
//import ShopSearch from "../../components/product/ShopSearch";
import ShopCategories from "../../components/product/ShopCategories";
import ShopSubCategories from "../../components/product/ShopSubCategories";

import ShopBrands from "../../components/product/ShopBrands";
import ShopTemplates from "../../components/product/ShopTemplates";
//import ShopSeasons from "../../components/product/ShopSeasons";

import ShopColor from "../../components/product/ShopColor";
import ShopSize from "../../components/product/ShopSize";
import ShopTag from "../../components/product/ShopTag";
//import ShopGender from "../../components/product/ShopGender";
import { useHistory } from "react-router-dom";

const ShopSidebar = ({
  products,
  getSortParams,
  sideSpaceClass,
  value,
  setSortValues,
}) => {
  const uniqueCategories = getUniqueCategories(products);
  const uniqueSubCategories = getUniqueSubCategories(products);
  const uniqueBrands = getUniqueBrands(products);
  const uniqueTemplates = getUniqueTemplates(products);
  const uniqueSeasons = getUniqueSeasons(products);

  const uniqueColors = getUniqueColors(products);
  const uniqueSizes = getProductsUniqueSizes(products);
  const uniqueTags = getUniqueTags(products);
  const [refresh, setRefresh] = useState(true);
  const [filter, setFilter] = useState(
    JSON.parse(sessionStorage.getItem("filter"))
  );
  const history = useHistory();
  function resetFiltri() {
    sessionStorage.setItem("filter", JSON.stringify({}));
    setSortValues({});
    setRefresh(!refresh);
    history.push("/redirect");
    setTimeout(
      () => history.push(process.env.PUBLIC_URL + "/shop-grid-full-width"),
      10
    );
    sessionStorage.setItem("currentPage", 1);
    //window.location.reload()
  }

  useEffect(() => {
    setFilter(JSON.parse(sessionStorage.getItem("filter")));
    //localStorage.setItem("currentPage", 1);
  }, [sessionStorage.getItem("filter")]);

  return (
    <div className={`sidebar-style ${sideSpaceClass ? sideSpaceClass : ""}`}>
      {/* shop search */}
      {/*<ShopSearch
        getSortParams={getSortParams}
  query={value} />*/}
      <h4 style={{ borderBottom: "1px solid black" }}>Filtri</h4>
      <div className="sidebar-widget sidebar-widget-tag">
        {filter?.brands?.split("|").map((brands, key) => {
          if (brands === "all") return;
          return (
            <button
              className={"brands active"}
              style={{
                border: "none",
                backgroundColor: "#2e98f0",
                color: "white",
                borderRadius: "50px",
                padding: "2px 17px",
              }}
            >
              {" "}
              <span className="checkmark" /> {brands}{" "}
            </button>
          );
        })}
        {filter?.subcategory?.split("|").map((subcategory, key) => {
          if (subcategory === "all") return;
          return (
            <button
              className={"brands active"}
              style={{
                border: "none",
                backgroundColor: "#2e98f0",
                color: "white",
                borderRadius: "50px",
                padding: "2px 17px",
              }}
            >
              {" "}
              <span className="checkmark" /> {subcategory}{" "}
            </button>
          );
        })}
        {filter?.category?.split("|").map((category, key) => {
          if (category === "all") return;
          return (
            <button
              className={"brands active"}
              style={{
                border: "none",
                backgroundColor: "#2e98f0",
                color: "white",
                borderRadius: "50px",
                padding: "2px 17px",
              }}
            >
              {" "}
              <span className="checkmark" /> {category}{" "}
            </button>
          );
        })}
        {filter?.templates?.split("|").map((template, key) => {
          if (template === "all") return;
          return (
            <button
              className={"brands active"}
              style={{
                border: "none",
                backgroundColor: "#2e98f0",
                color: "white",
                borderRadius: "50px",
                padding: "2px 17px",
              }}
            >
              {" "}
              <span className="checkmark" /> {template}{" "}
            </button>
          );
        })}
        {filter?.tag?.split("|").map((tag, key) => {
          if (tag === "all") return;
          return (
            <button
              className={"brands active"}
              style={{
                border: "none",
                backgroundColor: "#2e98f0",
                color: "white",
                borderRadius: "50px",
                padding: "2px 17px",
              }}
            >
              {" "}
              <span className="checkmark" /> {tag}{" "}
            </button>
          );
        })}
        {filter?.size?.split("|").map((size, key) => {
          if (size === "all") return;
          return (
            <button
              className={"brands active"}
              style={{
                border: "none",
                backgroundColor: "#2e98f0",
                color: "white",
                borderRadius: "50px",
                padding: "2px 17px",
              }}
            >
              {" "}
              <span className="checkmark" /> {size}{" "}
            </button>
          );
        })}
      </div>
      {/* filter by subcategories */}
      {/*<ShopSeasons
        seasons={uniqueSeasons}
        getSortParams={getSortParams}
      />*/}
      {/* filter by brands */}
      <ShopBrands
        brands={uniqueBrands?.sort()}
        getSortParams={getSortParams}
        refresh={refresh}
      />
      {/* filter by gender */}
      {/*<ShopGender
        genders={uniqueBrands}
        getSortParams={getSortParams}
      />*/}
      {/* filter by categories */}
      {global.aziendaID != 2 ? <ShopCategories
        categories={uniqueCategories?.sort()}
        getSortParams={getSortParams}
      /> : null}
      {/* filter by subcategories */}
      <ShopSubCategories
        subcategories={uniqueSubCategories?.sort()}
        getSortParams={getSortParams}
      />
      {/* filter by Templates */}
      <ShopTemplates
        templates={uniqueTemplates?.sort()}
        getSortParams={getSortParams}
      />
      {/* filter by color */}
      {global.aziendaID === 1 ? (
        <ShopColor colors={uniqueColors} getSortParams={getSortParams} />
      ) : null}
      {/* filter by size */}
      {global.aziendaID === 1 ? (
        <ShopSize sizes={uniqueSizes} getSortParams={getSortParams} />
      ) : null}
      {/* filter by tag */}
      {global.aziendaID != 2 ? <ShopTag tags={uniqueTags?.sort()} getSortParams={getSortParams} /> : null}
    </div>
  );
};

ShopSidebar.propTypes = {
  getSortParams: PropTypes.func,
  products: PropTypes.array,
  sideSpaceClass: PropTypes.string,
};

export default ShopSidebar;
